"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var omit_1 = __importDefault(require("lodash/omit"));
function forwardAs(ForwardedComponent, excludeProps) {
    var Component = react_1.forwardRef(function (_a, ref) {
        var _as = _a._as, props = __rest(_a, ["_as"]);
        var filteredProps = omit_1.default(props, (excludeProps || []));
        return react_1.default.createElement(ForwardedComponent, __assign({ as: _as, ref: ref }, filteredProps));
    });
    if (process.env.NODE_ENV !== 'production') {
        var forwardedComponentName = ForwardedComponent.displayName || ForwardedComponent.name || 'Component';
        Component.displayName = "ForwardedAs(" + forwardedComponentName + ")";
    }
    return Component;
}
exports.default = forwardAs;
